export const API = "/api";
// SERVICE
export const INVITE_SVC = "/invite-svc";

// VERSIONS
export const V2 = "/v2";

// ENTITIES
export const INVITES = "/invites";
export const OPERATION = "/operation";
export const USER = "/user";
export const INVITE = "/invite";
